/**
 * Compares an enum value with a primitive value (string or number).
 * Handles both numeric and string enums.
 */
export const enumEquals = <T extends string | number>(
	primitiveValue: string | number | null | undefined,
	enumValue: T | null | undefined
): boolean => {
	if (enumValue == null || primitiveValue == null) {
		return enumValue === primitiveValue;
	}

	return enumValue === primitiveValue || String(enumValue) === String(primitiveValue);
};
